import React, { useEffect } from 'react'
import { Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import Routes from '~/routes'

import history from '~/services/history'

import '~/config/ReactotronConfig'

import GlobalProvider from '~/contexts/GlobalContext'

import '~/styles/progress.css'
import '~/styles/toast.css'
import '~/styles/editor.css'
import '~/styles/tooltip.css'
import '~/styles/tour.css'
import 'react-tabs/style/react-tabs.css'

import GlobalStyle from '~/styles/global'
import TabsStyle from '~/styles/tabs'
import TooltipStyle from '~/styles/tooltip2'
import { TipProvider } from './contexts/TipContext'

export default function App() {
    const currentURL = window.location.href


    useEffect(() => {
        if (process.env.REACT_APP_ENVIRONMENT !== 'development' && !currentURL.includes('checkout')) {
            if(!currentURL.includes('codigo_etica')) {
                const script = document.createElement('script')

                script.src = 'https://chat.robot.rio.br/assistantCustomizedFile?userId=4'

                const chatJaIncluido = !!document.querySelector('script[src^="chat.robot.rio.br"]')

                if (!chatJaIncluido) {
                    document.body.appendChild(script)
                }
            }
        }
    }, [])

    return (
        <Router history={history}>
            <GlobalProvider>
                <TipProvider>
                    <Routes />
                </TipProvider>
            </GlobalProvider>

            <GlobalStyle />

            <TabsStyle />

            <TooltipStyle />

            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                pauseOnHover
                pauseOnVisibilityChange
                hideProgressBar
                draggable
            />
        </Router>
    )
}
